import { render, staticRenderFns } from "./OrderListExchangeSettle.vue?vue&type=template&id=23e4e98c&scoped=true"
import script from "./OrderListExchangeSettle.vue?vue&type=script&lang=js"
export * from "./OrderListExchangeSettle.vue?vue&type=script&lang=js"
import style0 from "./OrderListExchangeSettle.vue?vue&type=style&index=0&id=23e4e98c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4e98c",
  null
  
)

export default component.exports